import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import "./TicketSideBarItem.css";
import * as actionTypes from "../../../store/actions";
import loadTicketsArray from "../../../shared/functions/loadTicketsArray";

const TicketSideBarItemError = (props) => {
  /* const categoryTickets = useParams().categoryTickets; */
  const categoryTickets = props.categoryTickets;

  const onClickSideBarTicket = async () => {
    if (ticketErrorsLength !== 0) {
      props.setShouldResetTimer(true);
      if (props.numbersStateArray.length !== 0) {
        if (props.numbersStateArray.find((el) => el.isError === false)) {
          const loadedTicketsArray = await loadTicketsArray(categoryTickets)
          props.setTicketsArray(loadedTicketsArray)
        }
      }
      props.setLoadedBilet(
        props.ticketsArray.find((bilet) => bilet.ticketId === props.ticketId)
      );
      props.resetNumbersStateArray();
      props.setClickedAnswerId(null);
    }
    if (props.closeSideBarMobile) props.closeSideBarMobile();
    window.scrollTo(0, 0);
  };

  const [ticketErrorsLength, setTicketErrorsLength] = useState();

  useEffect(() => {
    setTicketErrorsLength(props.ticketErrors.length);
    if (
      props.numbersStateArray.length === props.ticketErrors.length &&
      props.paramsTicketId === props.ticketId &&
      props.categoryTickets === categoryTickets
    ) {
      const lsTicketErrors = JSON.parse(localStorage.getItem("errorsArray"));
      const [filteredErrorsArray] = lsTicketErrors.filter(
        (errorItem) =>
          parseInt(props.paramsTicketId) === errorItem.ticketId &&
          categoryTickets.slice(
            categoryTickets.length - 2,
            categoryTickets.length
          ) ===
            errorItem.ticketCategory.slice(
              errorItem.ticketCategory.length - 2,
              errorItem.ticketCategory.length
            )
      );
      setTicketErrorsLength(filteredErrorsArray.ticketErrors.length);
    }
  }, [
    props.numbersStateArray,
    props.ticketErrors.length,
    props.paramsTicketId,
    props.ticketId,
    categoryTickets,
    props.categoryTickets,
  ]);

  return (
    <Link
      onClick={onClickSideBarTicket}
      className={
        "ticket-item-link " + (ticketErrorsLength === 0 ? "non-pointer" : "")
      }
      to={`/${categoryTickets}/${props.ticketId}/${props.ticketErrors[0].taskId}/`}
    >
      <div
        className={
          "ticket-item " +
          (props.ticketId === props.paramsTicketId ? "active-ticket-item " : "")
        }
      >
        {"Битет " + props.ticketId}
        <div className="error-badge">{ticketErrorsLength}</div>
      </div>
    </Link>
  );
};
const mapStateToProps = (state) => {
  return {
    numbersStateArray: state.ticketsReducer.numbersStateArray,
    ticketsArray: state.ticketsReducer.ticketsArray,
    paramsTicketId: state.router.location.pathname.split("/")[2],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetNumbersStateArray: () =>
      dispatch({ type: actionTypes.RESET_NUMBERS_STATE_ARRAY }),
    setClickedAnswerId: (id) =>
      dispatch({
        type: actionTypes.SET_CLICKED_ANSWER_ID,
        clickedAnswerId: id,
      }),
    setLoadedBilet: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
    setTicketsArray: (ticketsArray) =>
      dispatch({
        type: actionTypes.SET_TICKETS_ARRAY,
        ticketsArray: ticketsArray,
      }),
    setShouldResetTimer: (flag) =>
      dispatch({
        type: actionTypes.SET_SHOULD_RESET_TIMER,
        shouldResetTimer: flag,
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketSideBarItemError);
